export enum MovementTransferType {
  NODE = 'node',
  FLOATING = 'floating',
}
